import React from 'react';

export const DivorceTextMid = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи;</p>
      <p>✔️підготовка позовної заяви;</p>
      <p>✔️формування справи для подачі в суд;</p>
      <p>✔️подача документів в суд;</p>
      <p>✔️моніторінг справи;</p>
      <p>✔️інструкція, як отримати рішення суду.</p>
    </>
  );
};
